"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.targetingQuery = exports.CircumstancesServiceTargetingQueryDesc = exports.ConfigResultServePlatform = exports.ClientTargetingExpressionPredicateOperator = exports.ClientTargetingExpressionProperty = exports.ClientTargetingExpressionOperator = exports.BenchmarkName = exports.RuidType = exports.Namespace = exports.ConfigTargetingResponse = exports.ConfigTargetingRequest = void 0;
const benchmark_name_1 = require("../generated/cdp/cof/benchmark_name");
Object.defineProperty(exports, "BenchmarkName", { enumerable: true, get: function () { return benchmark_name_1.BenchmarkName; } });
const config_request_1 = require("../generated/cdp/cof/config_request");
Object.defineProperty(exports, "ConfigTargetingRequest", { enumerable: true, get: function () { return config_request_1.ConfigTargetingRequest; } });
const config_response_1 = require("../generated/cdp/cof/config_response");
Object.defineProperty(exports, "ConfigTargetingResponse", { enumerable: true, get: function () { return config_response_1.ConfigTargetingResponse; } });
const config_result_1 = require("../generated/cdp/cof/config_result");
Object.defineProperty(exports, "ClientTargetingExpressionOperator", { enumerable: true, get: function () { return config_result_1.ClientTargetingExpression_Operator; } });
Object.defineProperty(exports, "ClientTargetingExpressionPredicateOperator", { enumerable: true, get: function () { return config_result_1.ClientTargetingExpression_PredicateOperator; } });
Object.defineProperty(exports, "ClientTargetingExpressionProperty", { enumerable: true, get: function () { return config_result_1.ClientTargetingExpression_Property; } });
Object.defineProperty(exports, "ConfigResultServePlatform", { enumerable: true, get: function () { return config_result_1.ConfigResult_ServePlatform; } });
const namespace_1 = require("../generated/cdp/cof/namespace");
Object.defineProperty(exports, "Namespace", { enumerable: true, get: function () { return namespace_1.Namespace; } });
const ruid_1 = require("../generated/common/ruid");
Object.defineProperty(exports, "RuidType", { enumerable: true, get: function () { return ruid_1.Ruid_Type; } });
const initConfigsClient_1 = require("./initConfigsClient");
exports.CircumstancesServiceTargetingQueryDesc = {
    methodName: "targetingQuery",
    service: {
        serviceName: "snapchat.cdp.cof.CircumstancesService",
    },
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return config_request_1.ConfigTargetingRequest.encode(this).finish();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, config_response_1.ConfigTargetingResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    },
};
/**
 * Fetches COF configs.
 * Wrapper around https://github.sc-corp.net/Snapchat/pb_schema/blob/507ec1a8029de217836e29778ddd95ab8b5b8de4/proto/cdp/cof/circumstance_service.proto#L18
 **/
function targetingQuery(request, metadata) {
    const { rpc } = initConfigsClient_1.getContextValidated();
    return rpc.unary(exports.CircumstancesServiceTargetingQueryDesc, config_request_1.ConfigTargetingRequest.fromPartial(request), metadata);
}
exports.targetingQuery = targetingQuery;
//# sourceMappingURL=targetingQuery.js.map